module.exports = __webpack_public_path__ + "img/mimg04.0e203ab9.jpg";